// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".table-cell > ul[data-v-112bd594] {\n  list-style: none;\n  display: table;\n  width: 100%;\n  table-layout: fixed;\n  padding-left: 12px;\n}\n.table-cell > li[data-v-112bd594] {\n  display: table-row;\n}\n.table-cell > b[data-v-112bd594] {\n  display: table-cell;\n  width: 110px;\n}\n.table-cell > span[data-v-112bd594] {\n  display: table-cell;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}", ""]);
// Exports
module.exports = exports;
